import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  consultcontroller: boolean = true;

  private cleanups: Array<() => void> = [];

  constructor(
    private router: Router,
    private zone: NgZone,
    private host: ElementRef<HTMLElement>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  /**
   * Scroll shrink + cursor highlight for the floating navbar. Both listeners
   * run outside the zone and write to the DOM directly — they fire far too
   * often to be allowed to trigger change detection.
   */
  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const nav = this.host.nativeElement.querySelector('nav');
    if (!nav) return;

    const onScroll = () =>
      nav.classList.toggle('is-scrolled', window.scrollY > 24);

    let queued = false;
    const onMove = (e: MouseEvent) => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        const r = nav.getBoundingClientRect();
        nav.style.setProperty('--hx', `${((e.clientX - r.left) / r.width) * 100}%`);
        nav.style.setProperty('--hy', `${e.clientY - r.top}px`);
      });
    };

    this.zone.runOutsideAngular(() => {
      window.addEventListener('scroll', onScroll, { passive: true });
      nav.addEventListener('mousemove', onMove, { passive: true });
      onScroll();
    });
    this.cleanups.push(() => {
      window.removeEventListener('scroll', onScroll);
      nav.removeEventListener('mousemove', onMove);
    });
  }

  ngOnDestroy(): void {
    this.cleanups.forEach((fn) => fn());
    this.cleanups = [];
    clearTimeout(this.servicesCloseTimer);
    clearTimeout(this.moreCloseTimer);
  }

  /**
   * Services mega menu. Desktop opens on hover intent; the close is delayed so
   * the pointer can cross the gap between the pill and the panel without the
   * menu snapping shut. Below 1000px the legacy in-drawer list takes over and
   * hover is ignored entirely.
   */
  private servicesCloseTimer: any;

  private get megaMenuEnabled(): boolean {
    return (
      isPlatformBrowser(this.platformId) &&
      window.matchMedia('(min-width: 1001px)').matches
    );
  }

  hoverServices(): void {
    if (!this.megaMenuEnabled) return;
    clearTimeout(this.servicesCloseTimer);
    this.first = true;
    this.isvisible = false;
  }

  scheduleCloseServices(): void {
    if (!this.megaMenuEnabled) return;
    clearTimeout(this.servicesCloseTimer);
    this.servicesCloseTimer = setTimeout(() => (this.first = false), 170);
  }

  closeServices(): void {
    clearTimeout(this.servicesCloseTimer);
    this.first = false;
  }

  /**
   * More mega menu. Same hover-intent contract as Services on desktop; below
   * 1000px it only ever opens on tap and renders as a full-screen panel over
   * the drawer, so hover is ignored.
   */
  private moreCloseTimer: any;

  hoverMore(): void {
    if (!this.megaMenuEnabled) return;
    clearTimeout(this.moreCloseTimer);
    this.isvisible = true;
    this.first = false;
  }

  scheduleCloseMore(): void {
    if (!this.megaMenuEnabled) return;
    clearTimeout(this.moreCloseTimer);
    this.moreCloseTimer = setTimeout(() => (this.isvisible = false), 170);
  }

  closeMore(): void {
    clearTimeout(this.moreCloseTimer);
    this.isvisible = false;
    // a link inside the panel navigates — the mobile drawer goes with it
    this.hidemenu = false;
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeServices();
    this.isvisible = false;
  }

  first?: boolean;
  hidemenu?: boolean;
  isvisible: boolean = false;

  @HostListener('document:click', ['$event.target'])
  documentClick(event: HTMLInputElement) {
    // The More trigger and its mega menu own their own open state — closing here
    // would cancel the toggle that fired a moment earlier, and would dismiss the
    // panel on any tap inside it.
    if (event?.closest?.('.more-trigger, app-more-mega-menu')) return;

    var drop = false;
    if (
      event.className == 'dropdowncontainer showdropdownnow' ||
      event.className == 'down_arrow'
    ) {
      drop = true;
    } else {
      drop = false;
    }
    if (!drop) {
      this.first = false;
      this.isvisible = false;
      // The drawer checkbox receives every hamburger tap; resetting hidemenu
      // here would cancel the toggle it just made, so it owns its own state.
      const isNavToggle =
        event.type === 'checkbox' &&
        !!event.closest &&
        !!event.closest('.navbar-container');
      if (!isNavToggle) this.hidemenu = false;
    }
  }

  changemenu1() {
    this.first = !this.first;
    if (this.first) {
      this.isvisible = false;
    }
  }
  changemenu2() {
    this.isvisible = !this.isvisible;
    if (this.isvisible) {
      this.first = false;
    }
  }

  checkHomeRoute() {
    if (this.router.url === '/') return true;
    return false;
  }
}
